<form [formGroup]="formGroup" (ngSubmit)="onSubmit()">
  <div class="row">
    <div class="form-floating mb-3 col-md">
      <input
        id="title"
        formControlName="title"
        class="form-control"
        placeholder="{{ 'announcement.form.title' | translate }}"
        [class.is-invalid]="submitted() && formGroup.controls.title.errors"
        required
      />
      <label for="title" class="form-label">{{ 'announcement.form.title' | translate }}*</label>
      <div class="invalid-feedback">{{ 'forms.required' | translate }}</div>
    </div>

    <div class="form-floating mb-3 col-md">
      <select
        id="appType"
        formControlName="appType"
        class="form-select"
        [class.has-value]="formGroup.controls.appType.value"
        [class.is-invalid]="submitted() && formGroup.controls.appType.errors"
        required
      >
        @for (option of appTypeOptions; track option) {
          <option [value]="option">{{ 'announcement.app-type.' + option | translate }}</option>
        }
      </select>
      <label for="appType" class="form-label">{{ 'announcement.form.app-type' | translate }}*</label>
      <div class="invalid-feedback">{{ 'forms.required' | translate }}</div>
    </div>
  </div>

  <div class="row">
    <div class="form-floating mb-3 col-md">
      <lib-multi-language-datepicker
        formControlName="start_date"
        [required]="true"
        class="form-control p-0 border-0"
        [class.is-invalid]="submitted() && formGroup.controls.start_date.errors"
      ></lib-multi-language-datepicker>
      <label for="start_date" class="form-label">{{ 'announcement.form.start-date' | translate }}*</label>
      <div class="invalid-feedback">{{ 'forms.required' | translate }}</div>
    </div>

    <div class="form-floating mb-3 col-md">
      <lib-multi-language-datepicker
        formControlName="end_date"
        [required]="true"
        class="form-control p-0 border-0"
        [class.is-invalid]="submitted() && formGroup.controls.end_date.errors"
      ></lib-multi-language-datepicker>
      <label for="end_date" class="form-label">{{ 'announcement.form.end-date' | translate }}*</label>
      <div class="invalid-feedback">{{ 'forms.required' | translate }}</div>
    </div>
  </div>

  @for (language of ['nl_NL', 'de_DE', 'en_US', 'fr_FR', 'fi_FI']; track language) {
    <div class="form-floating mb-3">
      <textarea
        [id]="language"
        [formControlName]="language"
        class="form-control"
        style="height: 100px"
        placeholder="{{ 'announcement.language.' + language | translate }}"
        [class.is-invalid]="submitted() && formGroup.get(language)?.errors"
        required
      ></textarea>
      <label [for]="language" class="form-label">{{ 'announcement.language.' + language | translate }}*</label>
      <div class="invalid-feedback">{{ 'forms.required' | translate }}</div>
    </div>
  }

  <div class="d-flex justify-content-end gap-2">
    <button type="button" class="btn btn-outline-primary" (click)="onCancel()">
      {{ 'buttons.cancel' | translate }}
    </button>

    <button type="submit" class="btn btn-primary" [disabled]="isLoading()">
      {{ 'buttons.save' | translate }}
    </button>
  </div>
</form>
